<template>
  <section class="categories-box">
    <h2 class="section-title">{{ view.title }}</h2>
    <div class="categories-filter">
      <div class="categories-filter__list categories-filter__list--desktop">
        <CategoryItem
          v-for="(tag, index) in view.tags"
          :key="tag"
          :tag="tag"
          :view="view"
          :itemIndex="index"
        />
      </div>
      <div :class="view.mobileClass">
        <CategoryItem
          v-for="tag in view.tags"
          :key="tag"
          :tag="tag"
          :view="view"
          :isMobile="true"
        />
      </div>

      <button
        v-if="view.tags.length > 6 && !view.showAllTags"
        class="categories-filter__btn categories-filter__btn--show"
        @click="view.toggleShowAllTags"
      >
        Show all categories
      </button>
      <button
        v-else-if="view.tags.length > 6"
        class="categories-filter__btn categories-filter__btn--hide"
        @click="view.toggleShowAllTags"
      >
        Hide categories
      </button>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { DocsTagsView } from '@/models/docs.tags'
import CategoryItem from './CategoryItem.vue'

defineProps<{
  view: DocsTagsView
}>()
</script>

<style lang="scss" scoped>
.categories-filter {
  &__list {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: 24px;

    @media only screen and (max-width: $w-pc-s) {
      gap: 8px;
    }
  }

  &__list--desktop {
    @media only screen and (max-width: $w-tablet-s) {
      display: none;
    }
  }

  &__list--mobile {
    display: none;

    @media only screen and (max-width: $w-tablet-s) {
      display: grid;
      grid-auto-flow: column dense; /* column flow with "dense" to fill all the cells */
      grid-template-rows: 105px 105px;
      grid-auto-columns: 140px;
      overflow: auto;
      scrollbar-width: none;
      -ms-overflow-style: none;
      &::-webkit-scrollbar {
        display: none;
      }
      @include full-width;
    }
  }

  &__list--mobile-oneline {
    @media only screen and (max-width: $w-tablet-s) {
      grid-template-rows: 115px;
    }
  }

  &__btn {
    display: block;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: $c-black-15;
    border: 1px solid $c-border-2;
    border-radius: 53px;
    padding: 11px 19px 9px;
    margin-top: 32px;
    margin-inline: auto;
    @include hover {
      background-color: $c-bg;
      border-color: $c-black-15;
      color: $c-black-15;
    }
    @media only screen and (max-width: $w-tablet-s) {
      display: none;
    }
  }
}
.night-mode {
  .categories-filter__btn {
    color: $c-dark-4;
    border-color: $c-dark-5;
    @include hover {
      background-color: $c-dark-2;
      border-color: $c-dark-7;
      color: $c-black-5;
    }
  }
}
</style>
